import { Switch } from "antd";
import { SwitchProps } from "antd/es/switch";

type Props = Pick<SwitchProps, "checked" | "disabled" | "onChange"> & {
  id: string;
  label: string;
};

export const EmailThumbnailSwitch = ({
  id,
  label,
  checked,
  disabled,
  onChange,
}: Props) => (
  <label
    className="email-thumbnail-switch-target"
    htmlFor={id}
    style={{ width: 44, minWidth: 44, height: 44 }}
  >
    <Switch
      id={id}
      aria-label={label}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
  </label>
);
